__turbopack_context__.v({
  "content": "error-module-scss-module__5C4lWq__content",
  "inner": "error-module-scss-module__5C4lWq__inner",
  "wrapper": "error-module-scss-module__5C4lWq__wrapper",
});
